<div
  class="text-widget flex-column flex-md-row row gx-4"
  [class.invert]="inverse()"
>
  <div
    class="col-md-6 col-sm-12 pt-2 bp-2 pt-md-0 z-1"
    [ngClass]="'text-widget__container--theme-' + theme"
  >
    <div class="text-widget__content-wrapper">
      <h2 class="text-widget__heading" *scText="title()"></h2>
      @if (showContent() && content(); as content) {
        <div class="mb-2" *scText="content"></div>
      }
    </div>
  </div>
  <div class="col-md-6 col-sm-12">
    @if (widget(); as widget) {
      <div class="text">
        <sc-placeholder name="widget-dynamic" [rendering]="widget" />
      </div>
    } @else {
      <div class="text-widget__placeholder">
        <span>+ Add a widget</span>
      </div>
    }
  </div>
</div>
